
import { accessNestedProperty } from './sharedMethods'

export default {
    stepState: (state) => (index) => {
        return state.surveyFlow[index]
    },
    //-------
    //-------
    stepField: (state, getters) => (address) => {        
        const stepState = getters.stepState(address[0])
        const localizedFieldAddress = [...address]
        localizedFieldAddress.shift()
        return accessNestedProperty(stepState, localizedFieldAddress)
    }
}